import { render, staticRenderFns } from "./MultipleSidebar.vue?vue&type=template&id=f7533ab4&scoped=true&"
import script from "./MultipleSidebar.vue?vue&type=script&lang=js&"
export * from "./MultipleSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MultipleSidebar.vue?vue&type=style&index=0&id=f7533ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7533ab4",
  null
  
)

export default component.exports